//Margin Component for horizontal Charts
import React from 'react';
import SliderWithInput from '../../SliderWithInput';

interface HorizontalMarginsProps {
  top: number;
  bottom: number;
  horizontalLeft: number;
  right: number;
  onChange: (option: string, value: number) => void;
  minMax?: { min: number; max: number; step: number };
  iconColor?: string;
}

const HorizontalChartsMargins: React.FC<HorizontalMarginsProps> = ({
  top,
  bottom,
  horizontalLeft,
  right,
  onChange,
  minMax = { min: 0, max: 50, step: 1 },
  iconColor,
}) => {
  return (
    <>
      <div
        className="optionDescription"
        style={{
          marginTop: '0px',
          paddingTop: '8px',
          color: iconColor ? iconColor : '#404040',
        }}
      >
        MARGIN RESIZE:
      </div>
      <div
        className="optionDescription"
        style={{
          marginTop: '0',
          color: iconColor ? iconColor : '#404040',
        }}
      >
        Top:
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={top}
        sliderMinMax={minMax}
        changeValue={(value) => onChange('top', value)}
      />
      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        Bottom:
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={bottom}
        sliderMinMax={minMax}
        changeValue={(value) => onChange('bottom', value)}
      />
      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        Left:
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={horizontalLeft}
        sliderMinMax={minMax}
        changeValue={(value) => onChange('horizontalLeft', value)}
      />
      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        Right:
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={right}
        sliderMinMax={minMax}
        changeValue={(value) => onChange('right', value)}
      />
    </>
  );
};

export default HorizontalChartsMargins;
